import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

const ActionsTable = ({ actions }) => (
  <div className='o-card__wrap'>
    <section className='column o-card cs-bg--light'>
      <h4><b>Actions</b></h4>
      {actions.length === 0 ? (
        <p>No actions found</p>
      ) : (
        <table className='o-table o-table--bordered'>
          <thead>
            <tr>
              <th>Id</th>
              <th>Type</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {actions.map((action) => (
              <tr key={action.id}>
                <td>{action.id}</td>
                <td>{action.action_type}</td>
                <td>{moment(action.created_at).format('MM/DD/YYYY')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  </div>
);

ActionsTable.propTypes = {
  actions: PropTypes.array.isRequired,
}

export default ActionsTable;
